var map = {
	"./Main.js": [
		894,
		894
	],
	"./Profile.js": [
		6620,
		9,
		620
	],
	"./ResetPassword.js": [
		6492,
		985,
		492
	],
	"./SignIn.js": [
		1760,
		985,
		760
	],
	"./SignUp.js": [
		1713,
		985,
		713
	],
	"./TableSettings.js": [
		4409,
		409
	],
	"./Tables.js": [
		7980,
		198,
		62,
		396
	],
	"./UserCabinet.js": [
		1077,
		9,
		77
	],
	"./Workspaces.js": [
		713,
		62,
		717
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 3703;
module.exports = webpackAsyncContext;